import useResizeWidthObserver from './useResizeWidthObserver';
import { TURBO_LIVE_ID } from '../constants';
import { isMobileChannel } from '../../../common/util';

const breakPointXl = 1540;
const breakPointLg = 1471;
const breakPointMd = 1240;

const minMobileColWidth = 180;

const getColsCount = width => {
    if (isMobileChannel()) {
        return Math.max(Math.trunc(width / minMobileColWidth) - 1, 1);
    } else if (width >= breakPointXl) {
        return 6;
    } else if (width >= breakPointLg) {
        return 5;
    } else if (width >= breakPointMd) {
        return 4;
    }
    return 3;
};

const useMediaColsCount = () => {
    const root = document.getElementById(TURBO_LIVE_ID);
    const width = useResizeWidthObserver({ current: root });
    return getColsCount(width);
};
export default useMediaColsCount;
